"use client";

import {setCookie, hasCookie, getCookie} from 'cookies-next';
import Script from "next/script";
import {useEffect, useState} from "react";
import {usePathname} from "next/navigation";
import * as pixel from "./pixel";

export default function FBPixel() {

    const [loaded, setLoaded] = useState(false);
    const [fbclid, setFbclid] = useState(undefined);
    const [externalId, setExternalId] = useState(undefined);
    const [fbup, setFbup] = useState(undefined);
    const pathname = usePathname();


    useEffect(()=>{
        const fbc = getCookie('_fbc');
        if(fbc){
            const fbcParts = fbc.split(".");
            if(fbcParts.length === 4){
                setFbclid(fbcParts[4]);
            }else{
                setFbclid(false);
            }
        }else{
            setFbclid(false);
        }
        const _externalId = getCookie('nf_uid');
        if(_externalId){
            setExternalId(_externalId);
        }

        const _fbup = getCookie('fbup');
        if(_fbup){
            // json parse fbup
            try {
                const fbupData = JSON.parse(_fbup);
                setFbup(fbupData);
            } catch (e) {
                console.error('Error parsing fbup cookie:', e);
            }
        }

    },[]);

    useEffect(() => {
        if (!loaded) return;

        pixel.pageview();
    }, [pathname, loaded]);


    useEffect(()=>{
        if(loaded){
            let initData = {};
            if(fbclid){
                initData.fbc = fbclid;
            }
            if(externalId){
                initData.external_id = externalId;
            }
            if(fbup){
                initData = {
                    ...initData,
                    ...fbup
                }
            }
            console.log('FB Pixel initialized with ID:', pixel.FB_PIXEL_ID, initData);

            window.fbq("init", pixel.FB_PIXEL_ID, initData);
        }
    },[loaded]);

    // This is the Facebook Pixel code

    return <>
        {fbclid!==null && <Script
            id={"facebook-pixel"}
            key={"facebook-pixel"}
            src="/scripts/pixel.js"
            strategy="afterInteractive"
            onLoad={() => setLoaded(true)}
            data-pixel-id={pixel.FB_PIXEL_ID}
            data-fbclid={fbclid}
            data-external-id={externalId}
        />}
    </>



}